<template>
  <div class="form-component" >
    <ul class="nav px-3 abs-tr">
      <li>
        <button type="button" @click="resetSearchData" :disabled="!isFilterActive" >Azzera filtri <span class="icon-rotate-cw"></span></button>
      </li>
    </ul>
    <form 
      class="position-relative form row p-3" 
      method="post" 
      @submit="checkForm"
      :action="action"
    >
      <div class="form-image col-sm-4 col--sep">
        <Mapsvg v-model="dove" :places="places" />
      </div>
      <div class="form-body col-sm-8">
        <div class="row">
          <div class="form-group" :class="{'col-sm-4': with_categoria_filter, 'col-sm-6': !with_categoria_filter}">
            <label for="dove">Luogo</label>
            <select class="custom-select" id="dove" name="dove" v-model="dove">
              <option value="">Tutta l'Italia</option>
              <option v-for="item in dove_options" :key="item.slug" :value="item.slug" >
                {{ item.name }}
              </option>
            </select>
          </div>

          <div class="form-group" :class="{'col-sm-4': with_categoria_filter, 'col-sm-6': !with_categoria_filter}">
            <label for="tribunale">Ente o Tribunale</label>
            <select class="custom-select" id="tribunale" name="tribunale" v-model="tribunale">
              <option value="">Tutti</option>
              <option v-for="item in tribunale_options" :key="item.slug" :value="item.slug" >
                {{ item.name }}
              </option>
            </select>
          </div>

          <div class="col-sm-4 form-group" v-if="with_categoria_filter">
            <label for="categoria">Categoria</label>
            <select class="custom-select" id="categoria" name="categoria" v-model="categoria">
              <option value="">Tutte</option>
              <option v-for="item in categoria_options" :key="item.slug" :value="item.slug" >
                {{ item.name }}
              </option>
            </select>
          </div>

          <div class="col-sm-4 form-group" v-if="with_procedura_filter">
            <label for="procedura">Numero procedura</label>
            <input type="text" class="form-control" id="procedura" name="procedura" v-model="procedura" placeholder="Numero" value="">
          </div>

          <div class="col-sm-4" v-if="with_price_filters">
            <label>Base d'asta</label>
            <div class="form-row">
              <div class="col">
                <label for="prezzo_da" class="sr-only">Prezzo minimo</label>
                <input type="number" class="form-control" id="prezzo_da" name="prezzo_da" v-model="prezzo_da" placeholder="Da" value="">
              </div>
              <div class="col">
                <label for="prezzo_a" class="sr-only">Prezzo massimo</label>
                <input type="number" class="form-control" id="prezzo_a" name="prezzo_a" v-model="prezzo_a" placeholder="A" value="">
              </div>
            </div>
          </div>

          <div :class="{'col-sm-4': with_price_filters, 'col-sm-12': !with_price_filters}">
            <label v-text="data_label"></label>
            <div class="form-row">
              <div class="col">
                <b-form-datepicker v-model="data_da" placeholder="Da" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" :max="data_a" right >
                  <template #button-content>
                    <span class="sr-only">Da</span><span class="icon-calendar"></span>
                  </template>
                </b-form-datepicker>  
                <input type="hidden" name="data_da" :value="data_da" />
              </div>
              <div class="col">
                <b-form-datepicker v-model="data_a" placeholder="A" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" :min="data_da" right >
                  <template #button-content>
                    <span class="sr-only">A</span><span class="icon-calendar"></span>
                  </template>
                </b-form-datepicker>  
                <input type="hidden" name="data_a" :value="data_a" />
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="custom-control custom-checkbox" v-if="with_confoto_filter">
              <input type="checkbox" class="custom-control-input" value="1" id="confoto" name="confoto" v-model="confoto">
              <label class="custom-control-label" for="confoto">Solo annunci con foto</label>
            </div>

            <div class="custom-control custom-checkbox" v-if="with_incorso_filter">
              <input type="checkbox" class="custom-control-input" value="1" id="incorso" name="incorso" v-model="incorso">
              <label class="custom-control-label" for="incorso">Solo bandi in corso</label>
            </div>
          </div>

          <div class="col-sm-6">
            <button type="submit" class="btn btn-blue btn-big w-100">Cerca</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Mapsvg from './Mapsvg.vue';

export default {
  props: {
    dove_options: {
      type: Array,
      default() {
        return []
      }
    },
    tribunale_options: {
      type: Array,
      default() {
        return []
      }
    },
    categoria_options: {
      type: Array,
      default() {
        return []
      }
    },
    action: {
      type: String,
      default: ''
    },
    places: {
      type: Object,
      default() {
        return {}
      }
    },
    dove_initial: String,
    tribunale_initial: String,
    categoria_initial: String,
    procedura_initial: String,
    data_da_initial: String,
    data_a_initial: String,
    prezzo_da_initial: String,
    prezzo_a_initial: String,
    confoto_initial: Boolean,
    incorso_initial: Boolean,
    data_label: String,
    with_categoria_filter: Boolean,
    with_procedura_filter: Boolean,
    with_price_filters: Boolean,
    with_confoto_filter: Boolean,
    with_incorso_filter: Boolean,
  },
  components: {
    Mapsvg
  },
  data () {
    return {
      dove: this.dove_initial,
      tribunale: this.tribunale_initial,
      categoria: this.categoria_initial,
      procedura: this.procedura_initial,
      data_da: this.data_da_initial,
      data_a: this.data_a_initial,
      prezzo_da: this.prezzo_da_initial,
      prezzo_a: this.prezzo_a_initial,
      confoto: this.confoto_initial,
      incorso: this.incorso_initial
    }
  },
  
  computed: {
    isFilterActive() {
      if (this.dove || this.tribunale || this.categoria || this.procedura || this.data_da || this.data_a || this.prezzo_a || this.prezzo_da) {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    // console.log(this._uid)
  },
  beforeDestroy () {
  },
  methods: {
    // https://v2.vuejs.org/v2/cookbook/form-validation.html
    // <p v-if="errors.length">
    //   <b>Please correct the following error(s):</b>
    //   <ul>
    //     <li v-for="error in errors">{{ error }}</li>
    //   </ul>
    // </p>
    checkForm: function (e) {
      console.log('check')
      return true;
      /*
      if (this.name && this.age) {
        return true;
      }

      this.errors = [];

      if (!this.name) {
        this.errors.push('Name required.');
      }
      if (!this.age) {
        this.errors.push('Age required.');
      }
      */

      e.preventDefault();
    },
    resetSearchData: function(e) {
      this.dove = ''
      this.tribunale = ''
      this.categoria = ''
      this.procedura = ''
      this.data_da = ''
      this.data_a = ''
      this.prezzo_da = ''
      this.prezzo_a = ''
    }
  }
}
</script>